<template>
  <div>
    <PageAllow
      controller="Orders"
      action="index"
    />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1 pe-2">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
                deleteIcon
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="order_code"
                    v-model="options.order_code"
                    @text="orderCodeKeyword = $event"
                    :label="$t('Order.Fields.order_code')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="ext_code"
                    v-model="options.ext_code"
                    @text="extCodeKeyword = $event"
                    :label="$t('Order.Fields.ext_code')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <!-- 商品 -->
                  <SearcherAccountMaterials v-model="materialSelected" />
                </v-col>
                <v-col cols="12" class="d-flex mt-2">
                  <SearcherStatus
                    v-model="orderStatus"
                    :label="$t('Order.status.title')"
                    :items="$consts.order.status.filter(
                          (element) =>
                            element.value == 1 ||
                            element.value == 3 ||
                            element.value == 5 ||
                            element.value == 6
                        )"
                  />
                  <v-spacer />
                  <SearcherStatus
                    v-model="options.pay_flgs"
                    :items="$consts.bill.pay_flgs"
                    :label="$t('Bill.payFlgs.title')"
                  />
                  <v-spacer />
                  <SearcherCancelFlgs v-model="options.cancel_flgs" />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="orders"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          mobile-breakpoint="800"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>

          <template v-slot:item.order_code="{ item, index }">
            <span
              class="text-no-wrap caption font-weight-bold"
              :v-resize="!index ? $stickTableResizer() : null"
            >
              {{ item.order_code }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.created | formatTime }}
            </span>
          </template>
          <template v-slot:item.shop.shop_name="{ item }">
            <span class="text-no-wrap">
              {{ item.shop.shop_name }}
            </span>
            <br />
            <span class="text-no-wrap caption secondary--text">
              {{ item.shop.shop_code }}
            </span>
          </template>
          <template v-slot:item.details_num_and_weight_total="{ item }">
            <span class="caption secondary--text text-no-wrap">
              {{
                $t("Order.Fields.details_num_unit", [
                  $numberFormatter.formatTwoDot(item.details_num),
                ])
              }}
            </span>
            <br />
            <span class="caption secondary--text text-no-wrap">
              {{
                $t("Order.Fields.weight_total_unit", [
                  $numberFormatter.formatTwoDot(item.weight_total),
                ])
              }}
            </span>
          </template>
          <template v-slot:item.order_price="{ item }">
            {{ $t("Global.money") }}{{ item.order_price | formatMoney }}
          </template>
          <template v-slot:item.expect_date="{ item }">
            <span class="caption secondary--text">
              {{ item.expect_date | formatTime }}
            </span>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              small
              label
              :color="item.status | orderStatusColor"
              :text-color="item.status | orderStatusTextColor"
              >{{ item.status | orderStatusText }}
            </v-chip>
            <br />
            <v-chip
              v-if="item.cancel_flg || item.error_flg"
              x-small
              label
              outlined
              color="danger"
            >
              {{
                item.cancel_flg
                  ? $t("CRUD.cancelled")
                  : $t("Order.redeliverError")
              }}
            </v-chip>
          </template>
          <template v-slot:item.bill.pay_flg="{ item }">
            <span class="text-no-wrap">
              <v-chip
                small
                label
                :color="item.bill.pay_flg | billPayFlgsColor"
                :text-color="item.bill.pay_flg | billPayFlgsTextColor"
                >{{ item.bill.pay_flg | billPayFlgsText }}
              </v-chip>
              <v-chip
                small
                label
                class="d-none ms-1"
                :color="item.bill.status | billStatusColor"
                :text-color="item.bill.status | billStatusTextColor"
                >{{ item.bill.status | billStatusText }}
              </v-chip>
            </span>
          </template>
          <template v-slot:item.origin_flg="{ item }">
            <v-chip
              style="height: auto"
              small
              label
              :color="item.origin_flg | orderOriginFlgsColor"
              :text-color="item.origin_flg | orderOriginFlgsTextColor"
              >{{ item.origin_flg | orderOriginFlgsText }}<br />
              ({{ item.creater_name }})
            </v-chip>
          </template>
          <template v-slot:item.account_memo="{ item }">
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  class="d-block text-truncate"
                  style="max-width: 80px"
                  >{{ item.account_memo }}
                </span>
              </template>
              {{ item.account_memo }}
            </v-tooltip>
          </template>
          <template v-slot:item.actions="{ item }">
            <OrderActions
              :order="item"
              showView
              :showEdit="item.actions.shop_edit"
              @done="getOrdersFromAPI()"
            />
          </template>
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherCancelFlgs from "@/components/plugins/SearcherCancelFlgs";
import SearcherAccountMaterials from "@/components/plugins/SearcherAccountMaterials";
import OrderActions from "./plugins/Actions";
import Orders from "@/api/orders";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000).toISOString().substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  actual_time_from: "",
  actual_time_to: "",
  expect_time_from: "",
  expect_time_to: "",
  order_code: "",
  ext_code: "",
  origin_flgs: [],
  shop_ids: [],
  district_codes: [],
  alliance_business_ids: [],
  status: [],
  pay_flgs: [1, 2, 3],
  cancel_flgs: [0],
  sortBy: [],
  sortDesc: [],
  material_ids: []
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherKeyword,
    SearcherStatus,
    SearcherCancelFlgs,
    SearcherAccountMaterials,
    OrderActions,
    // SearcherOrderOriginFlgs,
    // SearcherShops,
    // SearcherDistrict,
    // SearcherAlliances,

    // ImportExcelAlert,
    // DialogAlert,
  },

  computed: {
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.orderManagement"),
          disabled: false,
          replace: true,
          href: "/orders",
        },
      ];
      if (this.$route.path.startsWith("/orders-approve")) {
        items.push({
          text: i18n.t("Nav.ordersApprove"),
          disabled: true,
          href: "/orders-approve",
        });
      } else {
        items.push({
          text: i18n.t("Nav.orders"),
          disabled: true,
          href: "/orders",
        });
      }
      return items;
    },
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("Order.Fields.created_time"),
      },
      {
        key: "actual",
        text: i18n.t("Order.Fields.actual_time"),
      },
      {
        key: "expect",
        text: i18n.t("Order.Fields.expect_date"),
      },
    ],
    headers() {
      let headers = [
        {
          text:
            i18n.t("Order.Fields.order_code") +
            " / " +
            i18n.t("Order.Fields.created_time"),
          align: "start",
          sortable: false,
          value: "order_code",
        },
        // {
        //   text: i18n.t("Order.Fields.details_num_and_weight_total"),
        //   align: "end",
        //   sortable: false,
        //   class: "text-no-wrap",
        //   value: "details_num_and_weight_total",
        // },// 暂时不显示了
        {
          text: i18n.t("Order.Fields.order_price"),
          align: "end",
          sortable: false,
          class: "text-no-wrap",
          value: "order_price",
        },
        {
          text: i18n.t("Order.Fields.expect_date"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "expect_date",
        },
        {
          text: i18n.t("Order.Fields.status"),
          align: "center",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("Order.Fields.bill_pay_flgs"),
          // + " / " + i18n.t("Order.Fields.bill_status"),
          align: "center",
          sortable: false,
          value: "bill.pay_flg",
        },
      ];
      if (this.accountSettings && this.accountSettings.order_memo_display && this.accountSettings.order_memo_display == 1) {
        headers.push(
          {
            text: i18n.t("Order.Fields.account_memo"),
            align: "start",
            sortable: false,
            width: 120,
            value: "account_memo",
          },
        )
      } else if (this.accountSettings && this.accountSettings.order_memo_display && this.accountSettings.order_memo_display == 2) {
        headers.push(
          {
            text: i18n.t("Order.Fields.memo"),
            align: "start",
            sortable: false,
            width: 120,
            value: "memo",
          },
        )
      } else {
        headers.push(
          {
            text: i18n.t("Order.Fields.account_memo"),
            align: "start",
            sortable: false,
            width: 120,
            value: "account_memo",
          },
          {
            text: i18n.t("Order.Fields.memo"),
            align: "start",
            sortable: false,
            width: 120,
            value: "memo",
          },
        )
      }


      headers.push(
        {
          text: i18n.t("Order.Fields.origin_flg"),
          align: "center",
          sortable: false,
          value: "origin_flg",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      )
      return headers
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState([
      "loading",
      "stickTableCols",
      "mainContentScrolled",
      "fixHeaderHeightInPx",
      "accountInfo",
      "accountSettings",
    ]),
  },

  data: () => ({
    orderCodeKeyword: "",
    extCodeKeyword: "",
    materialSelected: [],
    options: JSON.parse(
      sessionStorage.getItem( "orders-options")
        ? sessionStorage.getItem("orders-options")
        : JSON.stringify(defaultOptions)
    ),
    batchImportBtnMenu: false,
    printBtnMenu: false,
    cloudPrintBtnMenu: false,
    paging: {},
    orders: [],
    ImportDialog: false,
    excelFile: null,
    selectShop: {},
    ImportByBuyerDialog: false,
    excelByBuyerFile: null,
    import_type: 0,
    errorCount: 0,
    successCount: 0,
    redeliverErrorCount: 0,
    error_order_id: [],
    unconfirmOrders: [],
    unconfirmOrderLength: 0,
    alreadyConfirmedOrderLength: 0,
    batchConfirmDialog: false,
    batchConfirmingInfoDialog: false,
    batchConfirmingInfo: i18n.t("Order.messages.batchConfirmingInfo", [0, 0]),
    cancelableOrders: [],
    cancelableOrderLength: 0,
    alreadyCanceledOrderLength: 0,
    batchCancelDialog: false,
    batchCancelInfoDialog: false,
    exportBtnMenu: false,
    confirmBtnMenu: false,
    approveBtnMenu: false,
    batchCancelInfo: i18n.t("Order.messages.batchCancelInfo", [0, 0]),
    approvableOrders: [],
    approvableOrderLength: 0,
    alreadyApprovedOrderLength: 0,
    batchApproveDialog: false,
    batchApproveInfoDialog: false,
    batchApproveInfo: i18n.t("Order.messages.batchCancelInfo", [0, 0]),
    batchApproveErrorDialog: false,
    batchApproveErrorData: [],
    errorOrders: [],
    ImportOrdersResultDialog: false,
    orderStatus: [],
  }),

  mounted() {
    this.$commonUtils
      .loadOptions("orders", [
        "materialSelected",
        "orderStatus"
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
            if (
              typeof this.options.created_time_from != "undefined" &&
              typeof this.options.created_time_to != "undefined"
            )
              this.datetimeRage = [
                this.options.created_time_from,
                this.options.created_time_to,
              ];
          } else this.resetSearch();

          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "materialSelected":
                this.materialSelected = selected.value;
                break;
              case "orderStatus":
                this.orderStatus = selected.value
            }
          });
        }.bind(this)
      );
  },

  watch: {
    $route() {
      this.$commonUtils
        .loadOptions("orders", [
          "materialSelected",
        ])
        .then(
          function (data) {
            if (data.options) {
              this.options = data.options;
              if (
                typeof this.options.created_time_from != "undefined" &&
                typeof this.options.created_time_to != "undefined"
              )
                this.datetimeRage = [
                  this.options.created_time_from,
                  this.options.created_time_to,
                ];
            } else this.resetSearch();

            data.selecteds.forEach((selected) => {
              switch (selected.key) {
                case "materialSelected":
                  this.materialSelected = selected.value;
                  break;
              }
            });
          }.bind(this)
        );
    },
    options: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getOrdersFromAPI();
        sessionStorage.setItem(
                "orders-options",
          JSON.stringify(this.options)
        );
      },
    },
    materialSelected: {
      handler() {
        this.options.material_ids = this.materialSelected
                ? this.materialSelected.map((e) => {
                  return e.id;
                })
                : "";
        sessionStorage.setItem(
                "orders-materialSelected",
          JSON.stringify(this.materialSelected)
        );
      },
    },
    orderStatus: {
      handler() {
        let status = []
        this.orderStatus.forEach((s) => {
          if (s == 3) {
            status.push(2)
            status.push(3)
          }
          else if (s ==5) {
            status.push(4)
            status.push(5)
          }
          else {
            status.push(s)
          }
        })
        this.options.status = status
        sessionStorage.setItem("orders-orderStatus", JSON.stringify(this.orderStatus));
      }
    }
  },

  methods: {
    resetSearch() {
      this.materialSelected = [];
      this.orderStatus = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.order_code, this.$refs.ext_code].forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        order_code: this.orderCodeKeyword,
        ext_code: this.extCodeKeyword,
      });
    },
    getOrdersFromAPI() {
      var options = JSON.parse(JSON.stringify(this.options));
      Orders.fetch(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.orders = response.data.orders;
            this.paging = response.data.paging;

            let unconfirmOrders = [];
            let cancelableOrders = [];
            this.orders.forEach((order) => {
              //取未审批的单子
              if (order.actions.confirm) {
                unconfirmOrders.push(order);
              }
              //取可作废的单子
              if (order.actions.cancel) {
                cancelableOrders.push(order);
              }
            });
            this.unconfirmOrders = unconfirmOrders;
            this.unconfirmOrderLength = unconfirmOrders.length;
            this.cancelableOrders = cancelableOrders;
            this.cancelableOrderLength = cancelableOrders.length;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    doPrint(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          var options = JSON.parse(JSON.stringify(this.options));
          options.page = 1;
          options.itemsPerPage = this.$consts.limitAll;
          switch (mode) {
            case "distributionPrint":
              this.$router.push({
                path: "/print/orders-distribution-print",
                query: options,
              });
              break;
            case "OrdersPrint":
              this.$router.push({
                path: "/print/orders-print/",
                query: options,
              });
              break;
          }
        }.bind(this)
      );
    },
  },
};
</script>